"use client";

import Quotes from "@homeinstead/icons/Quotes";

type TestimonialItemProps = {
  item: { name?: string | null; text?: string | null };
};

function TestimonialItem({ item }: TestimonialItemProps) {
  if (!item.text) {
    return null;
  }

  return (
    <figure className="flex flex-col gap-3">
      <Quotes aria-hidden="true" className="size-6 fill-surface-foreground" />
      <blockquote className="text-lg leading-relaxed">{item.text}</blockquote>
      {item.name ? (
        <figcaption className="font-semibold">{item.name}</figcaption>
      ) : null}
    </figure>
  );
}

export { TestimonialItem };
